import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import GuestHostDetails from './Details/GuestHostDetails';
import AdminEarning from './BillingInformation/AdminEarning';
import ReservationDetails from './Details/ReservationDetails';
import BillingInformation from './BillingInformation/BillingInformation';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import cs from '../../../components/commonStyle.css';
import as from '../admin-common.css';
import s from './ViewReservation.css';

const ViewReservation = ({ data, refetch, viewType }) => {
    let goBackURL, titleMessageKey;
    goBackURL = viewType === 'reservation' ? '/siteadmin/reservations' : (viewType === 'payout' ? '/siteadmin/payout' : '/siteadmin/refund');
    titleMessageKey = viewType === 'reservation' ? 'reservationDetails' : (viewType === 'payout' ? 'payoutDetails' : 'refundDetails');

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="print-reservation-container">
            <div className={cx(cs.displayFlex, cs.justifyContentSpaceBetween, cs.alignCenter, cs.gap8, cs.flexWrap, cs.space4)}>
                <h1 className={cx(s.titleText, cs.fontWeightBold)}><FormattedMessage {...messages[titleMessageKey]} /></h1>
                <div className={cx(cs.displayFlex, cs.gap8, 'hidden-print')}>
                    <button onClick={handlePrint} className={cx(cs.btnPrimaryBorder, cs.btnLarge)}>
                        <FormattedMessage {...messages.printText} />
                    </button>
                    <Link to={goBackURL} className={cx(cs.btnPrimaryBorder, cs.btnLarge, cs.noTextDecoration)}>
                        <FormattedMessage {...messages.goBack} />
                    </Link>
                </div>
            </div>
            <GuestHostDetails data={data} />
            <div className={cx(cs.displayGrid, cs.gridCols2, cs.gap24, cs.gridColsMobile1, cs.gapTab0, cs.gridColsTab1, 'print-details-grid')}>
                <div>
                    <AdminEarning data={data} />
                    <BillingInformation data={data} />
                </div>
                <div>
                    <ReservationDetails data={data} />
                </div>
            </div>
        </div>
    )
}

ViewReservation.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number.isRequired,
        listId: PropTypes.number.isRequired,
        hostId: PropTypes.string.isRequired,
        guestId: PropTypes.string.isRequired,
        checkIn: PropTypes.string.isRequired,
        checkOut: PropTypes.string.isRequired,
        guestServiceFee: PropTypes.number.isRequired,
        hostServiceFee: PropTypes.number.isRequired,
        taxPrice: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        reservationState: PropTypes.string.isRequired,
        listData: PropTypes.shape({
            title: PropTypes.string.isRequired
        }),
        hostData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
        }),
        hostPayout: PropTypes.shape({
            id: PropTypes.number.isRequired,
            payEmail: PropTypes.string.isRequired
        }),
        hostTransaction: PropTypes.shape({
            id: PropTypes.number.isRequired,
        }),
        guestData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
        }),
        refundStatus: PropTypes.shape({
            id: PropTypes.number.isRequired,
            receiverEmail: PropTypes.string.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired
        }),
        cancellationDetails: PropTypes.shape({
            refundToGuest: PropTypes.number.isRequired,
            payoutToHost: PropTypes.number.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
            guestServiceFee: PropTypes.number.isRequired,
            hostServiceFee: PropTypes.number.isRequired,
            cancellationPolicy: PropTypes.string,
            cancelledBy: PropTypes.string,
            isTaxRefunded: PropTypes.bool.isRequired,
        }),
    }),
    viewType: PropTypes.string
}

export default injectIntl(withStyles(s, cs, as)(ViewReservation));
